import { jsx as o } from "react/jsx-runtime";
import { CommentAvatarContainer as c, CustomAvatar as i } from "./style.js";
import { useTranslation as s } from "../../../../hooks/useTranslation/index.js";
function C({
  author: a,
  goToProfile: m,
  authorImage: r,
  className: n,
  size: e
}) {
  const { t } = s("common");
  return /* @__PURE__ */ o(c, { onClick: m, className: n, children: /* @__PURE__ */ o(
    i,
    {
      src: r,
      alt: `${t("comment-avatar-alt-text")} ${a || t("comment-avatar-alt-text-anonymous")}`,
      size: e
    }
  ) });
}
export {
  C as CommentAvatar
};
